<template>
    <div>
       <BaseS3FileList
            file-category="company"
            list-endpoint="vendorStandard.getFiles"
            :parent-id="resource.id"
            class="my-5"
            table-class="shadow-sm"
        />
    </div>
</template>

<script>
import BaseS3FileList from "@/components/s3_files/BaseS3FileList";

export default {
    components: {
        BaseS3FileList,
    },
    props: ["resource"],
};
</script>
